import { render, staticRenderFns } from "./stan_sheet.vue?vue&type=template&id=2a83d136"
import script from "./stan_sheet.vue?vue&type=script&lang=js"
export * from "./stan_sheet.vue?vue&type=script&lang=js"
import style0 from "./stan_sheet.vue?vue&type=style&index=0&id=2a83d136&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports